import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { Layout} from "../../components";
import { Component } from "react";
import { Link } from "react-router-dom";
// import { CheckCircle } from "@mui/icons-material";

class PaymentSuccess extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <Layout noBg noPadding title="">
        <Helmet>
          <title> پرداخت موفق | بیمه زندگی هامرز</title>
        </Helmet>
        <div className="payment-success">
          <div className="content-box">
            <div className="success-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <div className="message">
              <p className="title">پرداخت شما با موفقیت انجام شد</p>
              <p className="info">یک پیامک حاوی لینک تکمیل فرایند برای شما ارسال شده است</p>
              <p className="guide">لطفاً برای ادامه، روی لینک موجود در پیامک دریافتی کلیک نمایید</p>
            </div>
            <Link to="/dashboard" className="dashboard-button">
              بازگشت به داشبورد
            </Link>
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(PaymentSuccess);